import $ from 'jquery';

$(document).ready(function() {
    $('.js-get-started').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth:true,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 1440,
            settings: {
                slidesToShow: 1,
                variableWidth:true,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth:true,
                arrows: false,
                dots: false
           }
        }, 
        {
            breakpoint: 769,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                variableWidth:false,
                dots: false
            }
        }, 
        {
            breakpoint: 550,
                settings: {
                slidesToScroll: 1,
                slidesToShow: true,
                arrows: false,
                dots: false,
                variableWidth:true
            }
        }
        ]
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/index/get-started.js